import React from "react";
import Container from "./styled";
import { BsArrowLeft } from "react-icons/bs";
import { Link } from "react-router-dom";

const TitleSection = ({ tituloSpan, titulo, tag, descripcion }) => {

  return (
    <Container>
      {/* Max Width Container */}
      <div id="max-width-container">
        {/* Botón Atras */}
        <Link to="/" className="opacidad03">
          <span>
            <BsArrowLeft />
          </span>
          Inicio
        </Link>
        {/* Tag y Fecha Container */}
        <div id="tag-fecha-container" className="opacidad03">
          {/* Tag */}
          <div id="tag">
            <p>{tag}</p>
          </div>
          {/* Fecha */}
          <p id="fecha">{descripcion}</p>
        </div>
        {/* Titulo */}
        <h1 className="opacidad03">
          <span>{tituloSpan}</span>
          {titulo}
        </h1>
        {/* Edificios */}
        <div id="edificios-container" className="opacidad03">
          <img
            alt="Edificios del logo de Gestión y Servicios"
            src="/images/institucional/edificios.svg"
            id="edificios"
          ></img>
        </div>
      </div>
    </Container>
  );
};

export default TitleSection;
